// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.main-chat-container .custom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  /* Ensure the overlay is above other elements */
}
.main-chat-container .user-input {
  flex: 1 1;
  padding: 10px;
  border: none;
  border-radius: 5px;
  margin-right: 10px;
  border: 0;
}
.main-chat-container .user-input:focus {
  outline: none;
}
.main-chat-container .user-input::placeholder {
  font-weight: bold;
  font-size: 1em;
}
.main-chat-container .chat-history-container {
  display: flex;
  height: 100%;
  overflow-y: auto;
}
.main-chat-container .chat-history-container .prev-chat {
  width: 21%;
  background-color: #004987 !important;
  padding: 20px;
  box-sizing: border-box;
}
.main-chat-container .chat-history-container .chat-history {
  box-sizing: border-box;
  height: 90%;
  width: 100%;
}
.main-chat-container .chat-history-container .chat-history > .tab-content {
  height: 93%;
}
.main-chat-container .chat-history-container .chat-history > .tab-content .tab-pane {
  height: 100%;
}
.main-chat-container .chat-history-container .chat-history > .nav-tabs .nav-item,
.main-chat-container .chat-history-container .chat-history > .nav-tabs .nav-link {
  width: 10em;
}
.main-chat-container .chat-history-container .chat-history-with-menu {
  width: 79%;
}
.main-chat-container .chat-history-container .custom-dropdown {
  flex: 1 1 !important;
}
.main-chat-container .chat-history-container .custom-dropdown .dropdown .btn-primary {
  background-color: #004987 !important;
}
.main-chat-container .chat-history-container .evr-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.main-chat-container .chat-history-container .expand-arrow {
  display: flex;
  align-items: center;
}
.main-chat-container .chat-history-container .chat-history-evr {
  position: relative;
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  border: 2px solid black;
}
.main-chat-container .chat-history-container .chat-history-evr .evr-user-input {
  border: medium solid #004987;
}
.main-chat-container .chat-history-container .fullWidth {
  width: 100%;
}
.main-chat-container .chat-history-container .document-evr {
  position: relative;
  box-sizing: border-box;
  width: 48%;
  height: 100%;
  border: 2px solid black;
  display: flex;
  flex-direction: column;
}
.main-chat-container .chat-history-container .document-evr .header-content {
  margin-left: 0.5em;
  margin-bottom: 0.5em;
  border-style: double;
  border-color: #90c7eb;
  border-radius: 10px;
  border-width: medium;
}
.main-chat-container .chat-history-container .document-evr .title-container {
  display: flex;
  flex-direction: row;
  padding: 1em;
  font-weight: bold;
}
.main-chat-container .chat-history-container .document-evr .content-text {
  height: 10em;
}
.main-chat-container .chat-history-container .document-evr #content {
  resize: none !important;
}
.main-chat-container .chat-history-container .document-evr .description-container {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 80%;
}
.main-chat-container .chat-history-container .document-evr .action-conatiner {
  display: flex;
  padding: 5px;
  overflow: hidden;
  position: absolute;
  width: -webkit-fill-available;
  width: -moz-available;
  bottom: 0;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  border-top: 1px solid #ccc;
  padding: 5px;
}
.main-chat-container .chat-history-container .document-evr .btn-primary {
  background-color: #004987 !important;
}
.main-chat-container .chat-history-container .document-evr .w-10 {
  width: 10%;
}
.main-chat-container .chat-history-container .document-evr .w-90 {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/components/main-container/mainContainer.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;AACR;AAEI;EACI,SAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAMI;EACI,iBAAA;EACA,cAAA;AAJR;AASI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAPR;AASQ;EACI,UAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AAPZ;AAuBQ;EACI,sBAAA;EACA,WAAA;EACA,WAAA;AArBZ;AAwBQ;EACI,WAAA;AAtBZ;AAwBY;EACI,YAAA;AAtBhB;AA4BY;;EAEI,WAAA;AA1BhB;AA+BQ;EACI,UAAA;AA7BZ;AAgCQ;EACI,oBAAA;AA9BZ;AAmCgB;EACI,oCAAA;AAjCpB;AAsCQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AApCZ;AAuCQ;EACI,aAAA;EACA,mBAAA;AArCZ;AAwCQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,sBAAA;EACA,uBAAA;AAvCZ;AAyCY;EACI,4BAAA;AAvChB;AA2CQ;EACI,WAAA;AAzCZ;AA4CQ;EACI,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EAEA,uBAAA;EACA,aAAA;EACA,sBAAA;AA3CZ;AA6CY;EACI,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;AA3ChB;AA8CY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA5ChB;AA+CY;EACI,YAAA;AA7ChB;AAgDY;EACI,uBAAA;AA9ChB;AAkDY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAhDhB;AAmDY;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;AAjDhB;AAoDY;EACI,oCAAA;AAlDhB;AAqDY;EACI,UAAA;AAnDhB;AAsDY;EACI,UAAA;AApDhB","sourcesContent":[".main-chat-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n\n    .custom-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(255, 255, 255, 0.8);\n        /* Semi-transparent white background */\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 999;\n        /* Ensure the overlay is above other elements */\n    }\n\n    .user-input {\n        flex: 1;\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        margin-right: 10px;\n        border: 0;\n\n        &:focus {\n            outline: none;\n        }\n\n\n    }\n\n    .user-input::placeholder {\n        font-weight: bold;\n        font-size: 1em;\n        // opacity: 0.5;\n        // color: red;\n    }\n\n    .chat-history-container {\n        display: flex;\n        height: 100%;\n        overflow-y: auto;\n\n        .prev-chat {\n            width: 21%;\n            background-color: #004987 !important;\n            padding: 20px;\n            box-sizing: border-box;\n            // ::-webkit-scrollbar {\n            //     width: 12px;\n            // }\n\n            // ::-webkit-scrollbar-track {\n            //     -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222); \n            //     border-radius: 10px;\n            // }\n\n            // ::-webkit-scrollbar-thumb {\n            //     border-radius: 10px;\n            //     -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72); \n            // }\n        }\n\n        .chat-history {\n            box-sizing: border-box;\n            height: 90%;\n            width: 100%;\n        }\n\n        .chat-history>.tab-content {\n            height: 93%;\n\n            .tab-pane {\n                height: 100%;\n            }\n        }\n\n        .chat-history>.nav-tabs {\n\n            .nav-item,\n            .nav-link {\n                width: 10em;\n            }\n        }\n\n\n        .chat-history-with-menu {\n            width: 79%;\n        }\n\n        .custom-dropdown {\n            flex: 1 !important\n        }\n\n        .custom-dropdown {\n            .dropdown {\n                .btn-primary {\n                    background-color: #004987 !important;\n                }\n            }\n        }\n\n        .evr-container {\n            display: flex;\n            flex-direction: row;\n            height: 100%;\n        }\n\n        .expand-arrow {\n            display: flex;\n            align-items: center;\n        }\n\n        .chat-history-evr {\n            position: relative;\n            width: 50%;\n            height: 100%;\n            // background-color: red;\n            box-sizing: border-box;\n            border: 2px solid black;\n\n            .evr-user-input {\n                border: medium solid #004987;\n            }\n        }\n\n        .fullWidth {\n            width: 100%;\n        }\n\n        .document-evr {\n            position: relative;\n            box-sizing: border-box;\n            width: 48%;\n            height: 100%;\n            // background-color: skyblue;\n            border: 2px solid black;\n            display: flex;\n            flex-direction: column;\n\n            .header-content {\n                margin-left: 0.5em;\n                margin-bottom: .5em;\n                border-style: double;\n                border-color: #90c7eb;\n                border-radius: 10px;\n                border-width: medium;\n            }\n\n            .title-container {\n                display: flex;\n                flex-direction: row;\n                padding: 1em;\n                font-weight: bold;\n            }\n\n            .content-text {\n                height: 10em;\n            }\n\n            #content {\n                resize: none !important\n            }\n\n\n            .description-container {\n                display: flex;\n                flex-direction: column;\n                overflow-y: scroll;\n                height: 80%;\n            }\n\n            .action-conatiner {\n                display: flex;\n                padding: 5px;\n                overflow: hidden;\n                position: absolute;\n                width: -webkit-fill-available;\n                width: -moz-available;\n                bottom: 0;\n                align-items: center;\n                justify-content: space-evenly;\n                background-color: white;\n                border-top: 1px solid #ccc;\n                padding: 5px;\n            }\n\n            .btn-primary {\n                background-color: #004987 !important;\n            }\n\n            .w-10 {\n                width: 10%;\n            }\n\n            .w-90 {\n                width: 90%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
